export function htmlStringToNodeArray(str) {
  if (!str) return [];
  const htmlArr = [];
  let currentIndex = 0;

  while (currentIndex < str.length) {
    if (str[currentIndex] === '<') {
      const tagStart = currentIndex;
      const tagEnd = str.indexOf('>', tagStart);
      const openTag = str.slice(tagStart, tagEnd + 1);
      htmlArr.push(openTag);
      currentIndex = tagEnd;
    } else {
      const textStart = currentIndex;
      const textEnd = str.indexOf('<', textStart);
      const text = str.slice(textStart, textEnd);
      htmlArr.push(text);
      currentIndex = textEnd - 1;
    }
    currentIndex++;
  }

  return htmlArr;
}

export function stringifyMap(map) {
  return Array.from(map.entries())
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ');
}

export function extractTextFromRTE(node) {
  if (!node) return '';

  // If it's a text node
  if (node.text) {
    return node.text;
  }

  // If it has children, recursively extract
  if (Array.isArray(node.children)) {
    return node.children.map(extractTextFromRTE).join('');
  }

  return '';
}

export function removeParagraphsInsideLists(htmlString) {
  const replaced = htmlString.replace(
    /<li>(?:<p>(.*?)<\/p>)+<\/li>/g,
    '<li>$1</li>'
  );

  return replaced;
}
